/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DrmOperationInterval } from './DrmOperationInterval';
import {
    DrmOperationIntervalFromJSON,
    DrmOperationIntervalFromJSONTyped,
    DrmOperationIntervalToJSON,
} from './DrmOperationInterval';

/**
 * 
 * @export
 * @interface ReamingSlideDrmOperationInterval
 */
export interface ReamingSlideDrmOperationInterval extends DrmOperationInterval {
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    pressureMax: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    differentialPressure: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    tight: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    slackingOff: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    torqueMax: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1RepetitionsCount: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1RopUp: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1RopDown: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1RpmUp: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1RpmDown: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1FlowRateUp: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1FlowRateDown: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1Interval: number;
    /**
     * 
     * @type {number}
     * @memberof ReamingSlideDrmOperationInterval
     */
    reaming1StopPointOffBottom: number;
}

/**
 * Check if a given object implements the ReamingSlideDrmOperationInterval interface.
 */
export function instanceOfReamingSlideDrmOperationInterval(value: object): value is ReamingSlideDrmOperationInterval {
    if (!('pressureMax' in value) || value['pressureMax'] === undefined) return false;
    if (!('differentialPressure' in value) || value['differentialPressure'] === undefined) return false;
    if (!('tight' in value) || value['tight'] === undefined) return false;
    if (!('slackingOff' in value) || value['slackingOff'] === undefined) return false;
    if (!('torqueMax' in value) || value['torqueMax'] === undefined) return false;
    if (!('reaming1RepetitionsCount' in value) || value['reaming1RepetitionsCount'] === undefined) return false;
    if (!('reaming1RopUp' in value) || value['reaming1RopUp'] === undefined) return false;
    if (!('reaming1RopDown' in value) || value['reaming1RopDown'] === undefined) return false;
    if (!('reaming1RpmUp' in value) || value['reaming1RpmUp'] === undefined) return false;
    if (!('reaming1RpmDown' in value) || value['reaming1RpmDown'] === undefined) return false;
    if (!('reaming1FlowRateUp' in value) || value['reaming1FlowRateUp'] === undefined) return false;
    if (!('reaming1FlowRateDown' in value) || value['reaming1FlowRateDown'] === undefined) return false;
    if (!('reaming1Interval' in value) || value['reaming1Interval'] === undefined) return false;
    if (!('reaming1StopPointOffBottom' in value) || value['reaming1StopPointOffBottom'] === undefined) return false;
    return true;
}

export function ReamingSlideDrmOperationIntervalFromJSON(json: any): ReamingSlideDrmOperationInterval {
    return ReamingSlideDrmOperationIntervalFromJSONTyped(json, false);
}

export function ReamingSlideDrmOperationIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReamingSlideDrmOperationInterval {
    if (json == null) {
        return json;
    }
    return {
        ...DrmOperationIntervalFromJSONTyped(json, ignoreDiscriminator),
        'pressureMax': json['pressureMax'],
        'differentialPressure': json['differentialPressure'],
        'tight': json['tight'],
        'slackingOff': json['slackingOff'],
        'torqueMax': json['torqueMax'],
        'reaming1RepetitionsCount': json['reaming1RepetitionsCount'],
        'reaming1RopUp': json['reaming1RopUp'],
        'reaming1RopDown': json['reaming1RopDown'],
        'reaming1RpmUp': json['reaming1RpmUp'],
        'reaming1RpmDown': json['reaming1RpmDown'],
        'reaming1FlowRateUp': json['reaming1FlowRateUp'],
        'reaming1FlowRateDown': json['reaming1FlowRateDown'],
        'reaming1Interval': json['reaming1Interval'],
        'reaming1StopPointOffBottom': json['reaming1StopPointOffBottom'],
    };
}

export function ReamingSlideDrmOperationIntervalToJSON(value?: ReamingSlideDrmOperationInterval | null): any {
    if (value == null) {
        return value;
    }
    return {
        ...DrmOperationIntervalToJSON(value),
        'pressureMax': value['pressureMax'],
        'differentialPressure': value['differentialPressure'],
        'tight': value['tight'],
        'slackingOff': value['slackingOff'],
        'torqueMax': value['torqueMax'],
        'reaming1RepetitionsCount': value['reaming1RepetitionsCount'],
        'reaming1RopUp': value['reaming1RopUp'],
        'reaming1RopDown': value['reaming1RopDown'],
        'reaming1RpmUp': value['reaming1RpmUp'],
        'reaming1RpmDown': value['reaming1RpmDown'],
        'reaming1FlowRateUp': value['reaming1FlowRateUp'],
        'reaming1FlowRateDown': value['reaming1FlowRateDown'],
        'reaming1Interval': value['reaming1Interval'],
        'reaming1StopPointOffBottom': value['reaming1StopPointOffBottom'],
    };
}

